import { MantineProvider } from "@mantine/core";
import ApplicationShell from "./ApplicationShell";

// theme: #fed703

export default function App() {
  return (
    <MantineProvider withGlobalStyles withNormalizeCSS>
      <ApplicationShell />
    </MantineProvider>
  );
}
